import { Box, FormHelperText, Grid, IconButton, Theme, Typography, useMediaQuery, useTheme } from '@mui/material';
import React, { useState, useEffect } from 'react';
import OtpInput, { InputProps } from 'react-otp-input';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { maskMobileNumber } from '../../utils/utilityFunctions';
import { useDispatch } from 'react-redux';
import { sendOtp, verifyOtp } from '../../redux-store/actions/onBoarding';
import {
  ApplicationProps,
  CreateApplicationProps,
  SendOtpResponseBody,
  VerifyOtpResponseBody,
} from '../../redux-store/types/api-types';
import { addJointHolder, createApplication } from '../../redux-store/actions/application';
import { OtpTimer } from '../commonComponents';
import { Location } from 'history';
import { Formik } from '../../lib/formik/Formik';
import { MFSubmitButton } from '../../lib/formik';
import { showError } from '../../redux-store/actions/auth';
import { VERIFY_LOGIN_OTP_SUCCESS } from '../../redux-store/types/auth';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

const intialValues: { OTP: string } = {
  OTP: '',
};

export default function EnterOTP({
  location,
}: {
  location: Location<{
    mobile: string;
    unmaskedphone: string;
    umaskedemailId: string;
    otpVerificationToken: string;
    application: ApplicationProps;
    redirectTo: string;
    panVerificationToken: string;
    countryCode: string;
    email: string;
    countryNameAndCode: string;
    accountType: string;
  }>;
}): JSX.Element {
  const theme = useTheme()
  const isMd = useMediaQuery(theme.breakpoints.up('md'));
  const isSm = useMediaQuery(theme.breakpoints.up('sm'));

  const { path: currentPathName } = useRouteMatch();

  const { mobile = '', redirectTo = '', application, email = '' } = location.state || {};
  const { id } = application || {};
  const history = useHistory();
  const dispatch = useDispatch();
  const [error, setError] = useState<string>('');
  const [{ otpVerificationToken }, setOtpInfo] = useState({
    otpVerificationToken: '',
  });
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [isPasswordVisible, setPasswordVisible] = useState<boolean>(false)

  const isInvestorDiyOnboarding = currentPathName === '/investor-onboarding/enter-otp'
  const isDiyJointHolder = currentPathName.includes('add-diy-joint-holder')

  const handleSubmit = async (values: { OTP: string }) => {
    const { OTP } = values;
    try {
      if (!OTP || OTP.length !== 6) {
        setError('Enter OTP');
        return;
      }
      setIsLoading(true)
      const response = (await dispatch(
        verifyOtp({ otpVerificationToken, otp: OTP }, (isInvestorDiyOnboarding || isDiyJointHolder))
      )) as unknown as VerifyOtpResponseBody;
      if (response) {
        const { applicantVerificationToken, investorToken, role } = response || {};
        if (isInvestorDiyOnboarding) {
          dispatch({
            type: VERIFY_LOGIN_OTP_SUCCESS, body: {
              token: investorToken,
              role: role
            }
          })
        }
        if (id && redirectTo) {
          const res = (await dispatch(
            addJointHolder({ applicantVerificationToken }, id)
          )) as unknown as CreateApplicationProps;
          if (!res?.isSuccess) {
            dispatch(showError(res?.message as string));
            history.goBack();
            return;
          }
          history.push(redirectTo, { ...(res?.application || {}) });
          setIsLoading(false)
          return;
        }
        const res = (await dispatch(
          createApplication({ applicantVerificationToken })
        )) as unknown as CreateApplicationProps;

        if (!res) return

        if (!res?.isSuccess) {
          setIsLoading(false);
          dispatch(showError(res?.message as string));
          history.goBack();
          return;
        }
        // history.push('/application', { ...(res?.application || {}) });
        history.push(isInvestorDiyOnboarding ? '/investor-onboarding-application/personal-details' : '/application', { ...(res?.application || {}) });
        setIsLoading(false)
      }
    } catch (e) {
      console.error((e as Error).message);
    } finally {
      setIsLoading(false)
    }
  };

  useEffect(() => {
    const { otpVerificationToken } = location.state || {};
    if (!location.state) {
      history.push('/');
    }
    setOtpInfo({ otpVerificationToken });
  }, []);

  const onResend = async () => {
    try {
      const {
        panVerificationToken,
        countryCode,
        countryNameAndCode,
        email,
        unmaskedphone,
        umaskedemailId,
        accountType
      } = location.state;
      const res = (await dispatch(
        sendOtp({
          phoneNumber: unmaskedphone,
          emailId: umaskedemailId,
          panVerificationToken,
          countryCode,
          countryNameAndCode,
          bypassOtp: false,
          // ...((isInvestorDiyOnboarding || isDiyJointHolder) ? {
          //   accountType: isDiyJointHolder ? "" : "EXECUTIONARY"
          // } : { accountType })
          accountType
        }, (isInvestorDiyOnboarding || isDiyJointHolder))
      )) as unknown as SendOtpResponseBody;
      const { otpVerificationToken } = res || {};
      setOtpInfo({ otpVerificationToken });
    } catch (e) {
      console.error((e as Error).message);
    }
  };

  const togglePasswordVisibility = () => {
    setPasswordVisible(prevState => !prevState);
  }

  return (
    <Formik initialValues={intialValues} onSubmit={handleSubmit}>
      {({ values, setValues, handleSubmit }) => (
        <Grid
          container
          component="form"
          noValidate
          onSubmit={handleSubmit}
          px={4}
          rowSpacing={2.5}
        // sx={{
        //   '.MuiTypography-root': {
        //     fontSize: 16,
        //     fontWeight: 500,
        //     textAlign: 'center',
        //   },
        // }}
        >
          <Grid item xs={12}>
            <Typography
              variant='body_500'
              color="text.primary"
              sx={{ wordWrap: "break-word" }}
            >
              An OTP has been sent to your mobile number
              <Typography
                component="span"
                // sx={{ fontWeight: 'bold', color: 'primary.main', textDecoration: 'none' }}
                color="primary.500"
                variant='body_500'
              >
                {' '}
                {mobile}
              </Typography>
              {email && (
                <Typography
                  component="span"
                  color="text.primary"
                  variant='body_500'
                // sx={{ color: 'secondary.main' }}
                >
                  {' '}
                  and email Id{' '}
                  <Typography
                    component="span"
                    color="primary.500"
                    variant='body_500'
                  // sx={{ fontWeight: 'bold', color: 'primary.main', textDecoration: 'none' }}
                  >
                    {' '}
                    {email}
                  </Typography>
                </Typography>
              )}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Box
              role="group"
              aria-label="Enter OTP, 6 digit verification code"
              sx={{
                mb: 0,
                '.otp-input': {
                  input: {
                    width: { xs: '37px !important', md: '45px !important' },
                    fontSize: { xs: '20px !important', md: '30px !important' },
                    margin: { xs: '2px !important', md: '4px !important' },
                  },
                },
              }}>
              <OtpInput
                inputType='number'
                renderInput={(inputProps: InputProps) => (
                  <input
                    {...inputProps}
                    type={isPasswordVisible ? 'text' : 'password'}
                    style={{ ...inputProps.style }}
                    disabled={isLoading}
                  />
                )}
                value={values.OTP}
                onChange={(OTP: string) => setValues({ OTP })}
                numInputs={6}
                // hasErrored={!!error}
                // isInputNum={true}
                // isInputSecure={true}
                shouldAutoFocus={true}
                containerStyle={{
                  display: 'flex',
                  justifyContent: 'center',
                  // flexWrap: 'wrap',
                  // marginBottom: '30px',
                }}
                inputStyle={{
                  width: !isSm ? '35px' : !isMd ? '40px' : '45px',
                  height: !isSm ? '35px' : !isMd ? '40px' : '45px',
                  // margin: '5px',
                  backgroundColor: `${theme.palette.primary[500]}1A`,
                  // border: 0,
                  // borderBottom: '1px solid #979797',
                  // fontSize: '30px',
                  border: `1px solid ${theme.palette.primary[500]}`,
                  borderRadius: "5px",
                  outline: 'none',
                  borderColor: error ? `${theme.palette.error[900]}` : `${theme.palette.text.primary}`,
                  color: error ? `${theme.palette.error[900]}` : `${theme.palette.text.primary}`,
                  ...(theme.typography.body_600)
                }}
                renderSeparator={() => (
                  <span style={{ width: '6px' }}></span>
                )}
              // errorStyle={{ border: `1px solid ${theme.palette.error[500]}`, color: 'error.500' }}
              // focusStyle={{ outline: 'none' }}
              />
              {!!error && (
                <FormHelperText error sx={{ mt: 2, textAlign: 'center', fontSize: '14px' , color: `${theme.palette.error[900]}`, fontWeight: 500 }}>
                  {error}
                </FormHelperText>
              )}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: "0.5rem",
                }}
              >
                <IconButton
                  sx={{
                    display: "flex",
                    columnGap: "0.5rem",
                    borderRadius: "1rem",
                  }}
                  onClick={togglePasswordVisibility}
                  disabled={isLoading}
                >
                  {isPasswordVisible ? <VisibilityOffIcon fontSize="small" sx={(theme: Theme) => ({ color: theme.palette.textDark.secondary })} /> : <VisibilityIcon fontSize="small" sx={(theme: Theme) => ({ color: theme.palette.textDark.secondary })} />}
                  <Typography
                    variant='subtitle_600'
                    sx={{
                      color: theme.palette.textDark.secondary,
                      fontWeight: 500
                    }}
                  >
                    {isPasswordVisible ? "Hide OTP" : "Show OTP"}
                  </Typography>
                </IconButton>
              </Box>
            </Box >
          </Grid >
          <Grid item xs={12}>
            <OtpTimer onResend={onResend} />
          </Grid>
          <Grid item xs={12} mt={3}>
            <MFSubmitButton label="Submit" loadingEnable={isLoading} />
          </Grid>
        </Grid >
      )
      }
    </Formik >
  );
}

// export function RedirectScreen(): JSX.Element {
//   return (
//     <>
//       <Typography sx={{ fontSize: 24, fontWeight: 'bold', color: 'primary.main' }}>
//         You are now being redirected to Onboard Investor Form
//       </Typography>
//       {/* <MFSubmitButton label="Next" to="/distributor-details" /> */}
//     </>
//   );
// }
